import { Input, Component, Output, EventEmitter } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { CurrencyCustomPipe } from 'src/app/core/pipe/pipe-currencyCustom';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../view/view.service';
import { LINKS_CONFIG } from 'src/app/configs';

declare var $:any;

@Component({
    selector: 'ad',
    template: `<div #container></div>`
  })
export class AdComponent extends AdUtils{

  @Input() data: any = {};
  @Input() template : any = 'default';
  @Input() tagClass = '';
  @Input() scroll = null;
  @Input() last = false;
  @Input() extra:any = {};

  @Output() callback = new EventEmitter();

  indexes:any = [];

  slot = 1;

  constructor(
    protected srs : AdSearchService,
    protected gs : GeneralService,
    protected vs : ViewService
  ){
    super(srs, gs, vs);

    this.indexes = this.gs.settingsData?.indexes || [];
  }
  /*
  ngOnInit(){
    console.log(this.data);
    if(this.data?.friendlyTitle){
      this.loadAd();
    } else
      this.setDefault();
          
  }
  */

  private _actionForward: string;
  get actionForward(): string { return this._actionForward; }
  set actionForward(newVal: string) {
    if (this._actionForward === newVal) { return; }
    this._actionForward = newVal;

    switch(newVal){
      case 'view':
        this.view(newVal);
      break;
    }
  }

  eventCallback(event){
    this.callback.emit({event: event, data: this.data});

    if(this.template == 'admin'){
      if(event.type=='click')
        this.openDropdown(event);
      if(event.type=='mouseout-card')
        this.closeDropdown(event);
    }
  }

  changeImageSlot(){
    this.slot = this.slot == 2? 1 : 2;
  }

  setDefault(){
    
    if(this.data.loading)
      return;

    if(this.data?.friendlyTitle)
      this.setSummary();

    let innerHits = !!this.data?.inner_hits?.units || false;
    
    this.data.loading = false;
    this.data._cover = this.getCover('medium');
    this.data._coverThumb = this.getCover('thumb');
    
    this.data._roomText = this.getSummary('room',innerHits);
    this.data._privateArea = this.getSummary('privateArea',innerHits);
    this.data._totalArea = this.getSummary('totalArea',innerHits);
    this.data._bathroom = this.getSummary('bathroom',innerHits);
    this.data._garage = this.getSummary('garage',innerHits);
    this.data._brand = this.getSummary('brand',innerHits);
    this.data._model = this.getSummary('model',innerHits);
    this.data._km = this.getSummary('km',innerHits);
    this.data._year = this.getSummary('year',innerHits);
    this.data._color = this.getSummary('color',innerHits);
    
    let currencyCustom = new CurrencyCustomPipe();
    let amountMin = this.getSummary('amountMin',innerHits);
    let amountMax = this.getSummary('amountMax',innerHits);

    this.data._amountMin = amountMin == ''? 0 : currencyCustom.transform(amountMin, false, 'pt','R$');
    this.data._amountMinShort = amountMin == ''? 0 : currencyCustom.transform(amountMin, 'short', 'pt','R$');
    this.data._amountMaxShort = amountMax == ''? 0 : currencyCustom.transform(amountMax, 'short', 'pt','R$'); 

    this.data._category = this.gs.getFeatureCategory(this.data?.categoryId)?.name;
    this.data._available = this.getSummary('available',innerHits);
    this.data._address = this.getAddress('card-street');
    this.data._address2 = this.getAddress('card-city');
    this.data._address3 = this.getAddress('card');
    this.data._published = this.getDate('update');
    
    this.data._feature = this.getStatus('feature');
    this.data._featureStatus = this.getStatus('feature',null,'tag_id');

    this.data._restrictedAllowed = this.gs.restrictedAllowed(this.data);
   
    let firstpub = this.data?.firstPublish? new Date(this.data?.firstPublish?.substring(0,19)) : false;

    this.data._new = firstpub? this.gs.calculateDiff(firstpub) <= (this.gs.settingsData?.newDays || 10) : false;
    
    this.data._status = this.getStatus('ad');

    this.data._ownerName = this.getOwner('personName');
    this.data._ownerVerified = this.getOwner('verified');

    if(this.data?.owner?.avatar){
      this.data.owner.avatar = this.gs.adjustAvatarFiles(this.data.owner);
      this.data._ownerAvatarImg = this.getOwner('image');
    }
  }

  imgDidLoad(event){
    this.gs.imgDidLoad(event);
  }
  openDropdown(event:any){
    //event?.stopPropagation();
    $('.dropdown-menu.active').removeClass('active over');
    let obj = $(event.target);
    let card = obj.parents('.card');
    let cardpos = card.offset();
    let dropdown = card.find('.dropdown-menu');
    let scrolltop = $(document).scrollTop();
    
    dropdown.css('top',event.y - cardpos.top + scrolltop).css('left',event.x - cardpos.left).addClass('active');//obj.height()+20) //(cardpos.top < event.y? event.y - cardpos.top : cardpos.top - event.y) - scrolltop

    dropdown.off('mouseover').on('mouseover',function (ev) {
      $(this).addClass('over');
    });
    document.addEventListener("mousemove", this.closeDropdown);
    document.addEventListener("click", this.closeDropdown);

  }
  closeDropdown(ev){
    let target = ev?.target || ev?.event?.target;

    if(((ev.type=='mousemove' && !!$('.dropdown-menu.active.over')?.length) || ev.type=='click' || ev.type=='mouseout-card') && !$(target).parents('.dropdown-menu')?.length && !$(target).parents('.card').find('.dropdown-menu.active')?.length){
      $('.dropdown-menu.active').removeClass('active over');
      document.removeEventListener('mousemove',this.closeDropdown);
      document.removeEventListener('click',this.closeDropdown);
    }        
  }
  

}  